// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"8862f023","201":"755744d6","787":"3e295ed5"}[chunkId] + ".chunk.js";
};